import { Component, Input, OnInit } from '@angular/core';

import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';
import { AccountingConnection } from '../../../../../../../models/organization-config';
import { LocationService } from '../../../../../../../services/location/location.service';
import { AccountService } from '../../../../../../../services/account/account.service';
import { CapitanLocation } from '../../../../../../../models/location';
import { OrganizationConfigService } from '../../../../../../../services/organization-config/organization-config.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-assign-accounting-connection-modal',
  templateUrl: './assign-accounting-connection-modal.component.html',
  styleUrls: ['./assign-accounting-connection-modal.component.css']
})
export class AssignAccountingConnectionModalComponent implements OnInit {
  @Input() savedCallback: (result: CallbackResult) => undefined;
  @Input() conn: AccountingConnection;
  public selectedLocationIds: number[] = [];

  public locations: CapitanLocation[];

  public loadingLocations = true;
  public loadingSave = false;

  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    private accountService: AccountService,
    private locationService: LocationService,
    private orgConfigService: OrganizationConfigService
  ) {}


  ngOnInit() {
    for (const locationId of this.conn.location_ids) {
      this.selectedLocationIds.push(locationId);
    }

    this.loadLocations();
  }

  public handleSubmit() {
    this.loadingSave = true;

    this.errorMessage = '';

    this.orgConfigService
      .assignAccountingConnectionLocations(this.conn, this.selectedLocationIds)
      .then(() => {
        this.savedCallback({
          text: 'Accounting connection reassigned successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.stattus === 403) {
          this.errorMessage = 'You do not have permission to make this assignment.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSave = false; });
  }

  public toggleLocationId(locationId: number) {
    if (this.selectedLocationIds.includes(locationId)) {
      this.selectedLocationIds.splice(this.selectedLocationIds.indexOf(locationId), 1);
    } else {
      this.selectedLocationIds.push(locationId);
    }
  }

  private loadLocations() {
    this.loadingLocations = true;

    this.locationService
      .loadLocations()
      .then(() => {
        this.locations = this.locationService.getLocations();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingLocations = false; });
  }
}
